import { Fab } from '@mui/material'
import styled from 'styled-components'

export const FabButtonStyled = styled(Fab).attrs(() => {
  return {
    color: 'primary',
    size: 'small',
    sx: {
      position: 'fixed',
      bottom: 'calc(16px + env(safe-area-inset-bottom))',
      right: 16,
    },
  }
})(() => ({}))
